The total number of webhook subscriptions in the entire list.
This is not influenced by pagination parameters.
